import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import { Platform } from 'react-native';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import useDeviceType from 'src/customizations/themes/hooks/useDeviceType';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { renderAdminStackRoutes } from 'src/modules/admin/adminStackRoutes';
import useIsSuperAdmin from 'src/modules/authentication/hooks/useIsSuperAdmin';
import { renderDebugStackRoutes } from 'src/modules/debug/debugStackRoutes';
import { renderNotificationStackRoutes } from 'src/modules/notification/notificationStackRoutes';
import { renderReviewPipelineStackRoutes } from 'src/modules/review-pipeline/reviewPipelineStackRoutes';
import { renderSTCStackRoutes } from 'src/modules/support-the-creators/stcStackRoutes';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { renderUserStackRoutes } from 'src/modules/user/userStackRoutes';
// import { renderCommunityStackRoutes } from 'src/modules/community/communityStackRoutes';
import { renderExamPreparationStackRoutes } from '../modules/exam-preparation/examPreparationStackRoutes';
import DesktopSidebar from './components/DesktopSidebar';
import NavigationWrapper from './NavigationWrapper';
import { renderTabStackRoutes } from './TabNavigation';
export const RootStack = createNativeStackNavigator();
const stackNavigationOptions = {
    headerShown: false,
    gestureEnabled: Platform.OS === 'ios',
};
const RootNavigation = ({ ...navigationWrapperProps }) => {
    const isSuperAdmin = useIsSuperAdmin();
    const { translate } = useI18n();
    const deviceType = useDeviceType();
    const [{ theme }] = useTheme();
    const routeRenderProps = { translate };
    const navigator = (React.createElement(RootStack.Navigator, { initialRouteName: "Tabs", screenOptions: stackNavigationOptions },
        renderTabStackRoutes(routeRenderProps),
        renderExamPreparationStackRoutes(routeRenderProps),
        renderNotificationStackRoutes(routeRenderProps),
        renderUserStackRoutes(routeRenderProps),
        renderReviewPipelineStackRoutes(routeRenderProps),
        __DEV__ && renderDebugStackRoutes(routeRenderProps),
        renderSTCStackRoutes(routeRenderProps),
        isSuperAdmin && renderAdminStackRoutes(routeRenderProps)));
    return (React.createElement(NavigationWrapper, { ...navigationWrapperProps }, deviceType.isDesktop ? (React.createElement(Row, { flex: true, bg: theme.palette.background.main },
        React.createElement(DesktopSidebar, null),
        React.createElement(Column, { flex: true, bg: theme.palette.background.main }, navigator))) : (navigator)));
};
export default RootNavigation;
